<script>
export default {
    name: 'IconLinkedin',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-linkedin"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M18.192 56H7.826V22.618h10.366V56zm-5.189-37.936C9.69 18.064 7 15.318 7 12.004a6.003 6.003 0 1 1 12.007 0c0 3.314-2.69 6.06-6.004 6.06zM56.99 56H46.645V39.75c0-3.873-.078-8.84-5.39-8.84-5.389 0-6.215 4.208-6.215 8.56V56H24.685V22.618h9.942v4.553h.145c1.384-2.623 4.765-5.39 9.808-5.39C55.071 21.78 57 28.688 57 37.662V56h-.011z"
        />
    </svg>
</template>
